import { Reason } from "../../common/enums/reason.enum";

// Dictionary names are stored in Polish in the database
const dictionaryNameKeys: { [name: string]: string } = {
  "Deaktywacji klienta": "cancellationReasons.groups.clientDeactivation",
  "Anulowania zamówienia": "cancellationReasons.groups.orderCancel",
};

export const dictionaryTypes: Reason[] = [Reason.ClientDeactivation, Reason.OrderCancel];

// Translates a dictionary (reason group) name for display; unknown names are returned as they are
export const translateDictionaryName = (name: string, t: (key: string) => string): string =>
  dictionaryNameKeys[name] !== undefined ? t(dictionaryNameKeys[name]) : name;
